"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCeloState = void 0;
var base_1 = require("@celo/contractkit/lib/base");
var react_1 = require("react");
var connectors_1 = require("./connectors");
var constants_1 = require("./constants");
var use_is_mounted_1 = require("./hooks/use-is-mounted");
var react_celo_reducer_1 = require("./react-celo-reducer");
var get_initial_network_1 = require("./utils/get-initial-network");
var helpers_1 = require("./utils/helpers");
var resurrector_1 = require("./utils/resurrector");
var initialState = {
  connector: new connectors_1.UnauthenticatedConnector(constants_1.Mainnet),
  connectorInitError: null,
  manualNetworkMode: false,
  dapp: {
    name: 'Celo dApp',
    description: 'Celo dApp',
    url: 'https://celo.org',
    icon: 'https://celo.org/favicon.ico'
  },
  walletChainId: null,
  network: constants_1.Mainnet,
  networks: constants_1.DEFAULT_NETWORKS,
  pendingActionCount: 0,
  address: null,
  connectionCallback: null,
  feeCurrency: base_1.CeloContract.GoldToken,
  theme: null
};
function useDispatch(dispatch) {
  var isMountedRef = (0, use_is_mounted_1.useIsMounted)();
  return (0, react_1.useCallback)(function (type) {
    if (isMountedRef.current) {
      dispatch({
        type: type,
        payload: arguments.length <= 1 ? undefined : arguments[1]
      });
    }
  }, [dispatch, isMountedRef]);
}
function useCeloState(_ref) {
  var dapp = _ref.dapp,
    network = _ref.network,
    defaultNetwork = _ref.defaultNetwork,
    manualNetworkMode = _ref.manualNetworkMode,
    theme = _ref.theme,
    networks = _ref.networks,
    feeCurrency = _ref.feeCurrency;
  var _a;
  var stateFromLocalStorage = (0, react_1.useMemo)(function () {
    return (0, helpers_1.loadPreviousState)();
  },
  // We only want this to run on mount so the deps array is empty.
  // This is OK because the stateFromLocalStorage is only used to create the initial reducer state
  /* eslint-disable-next-line */
  []);
  var connector = (0, react_1.useMemo)(function () {
    return (0, resurrector_1.resurrector)(networks, dapp, manualNetworkMode !== null && manualNetworkMode !== void 0 ? manualNetworkMode : initialState.manualNetworkMode);
    /* eslint-disable-next-line */
  }, []);
  var initialNetwork = (0, get_initial_network_1.getInitialNetwork)(networks, defaultNetwork, network, stateFromLocalStorage.networkName);
  var _ref2 = (0, react_1.useReducer)(react_celo_reducer_1.celoReactReducer, Object.assign(Object.assign({}, initialState), {
      manualNetworkMode: manualNetworkMode !== null && manualNetworkMode !== void 0 ? manualNetworkMode : initialState.manualNetworkMode,
      address: stateFromLocalStorage.address,
      connector: connector || initialState.connector,
      network: initialNetwork,
      feeCurrency: stateFromLocalStorage.feeCurrency || feeCurrency || base_1.CeloContract.GoldToken,
      networks: networks,
      theme: theme,
      dapp: Object.assign(Object.assign({}, dapp), {
        icon: (_a = dapp.icon) !== null && _a !== void 0 ? _a : "".concat(dapp.url, "/favicon.ico")
      })
    })),
    _ref3 = _slicedToArray(_ref2, 2),
    state = _ref3[0],
    _dispatch = _ref3[1];
  var dispatch = useDispatch(_dispatch);
  return [state, dispatch];
}
exports.useCeloState = useCeloState;